import { OutlinedTextFields } from './texField';

export default OutlinedTextFields;
